import { isString } from '../fold-helpers';
import { createWidgetNormalizer } from '../create-widget-normalizer';

const CONTENT_SYNONYM_KEYS = ['text', 'html', 'value'] as const;

/**
 * The normalization shared by `create_text_widget` and `update_text_widget` — identical for both,
 * unlike button's (whose create/update disagree on the `buttons` wrapper), because a text patch and
 * a text create body carry the exact same flat field surface.
 *
 * Two real synonym classes are folded:
 *
 * - **content**: models reach for `text`/`html`/`value` (and sometimes put it at the top level
 *   next to `columnId` rather than inside `data`) far more readily than the schema's `content`.
 *   A plain `z.object()` strips those SILENTLY — on create that used to mean a hard "content
 *   required" failure with no hint why, on update a success-reporting no-op.
 * - **horizontalAlign**: `align`/`textAlign`/`alignment` as the key, `left`/`center`/`right` as
 *   the value — see `foldHorizontalAlign`.
 */
const textNormalizer = createWidgetNormalizer({
    rules: [{ target: 'content', synonyms: CONTENT_SYNONYM_KEYS, accepts: isString }],
    horizontalAlign: true,
});

export function normalizeTextWidgetArgs(raw: unknown): unknown {
    return textNormalizer.normalize(raw);
}
